export default __webpack_public_path__ + "static/media/Level24.d105c37c.svg";